import { Box, Text } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { CurrencyType, SettledAmountDto } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList } from '@tiendanube/components';
import { CurrencyPrice } from 'commons/components';
import { SettledAmount } from 'domains/Orders/components';

interface Attributes {
  currency: CurrencyType;
  total: number;
  settledAmount?: SettledAmountDto;
}

function OrderSubtotalAmountRow({
  total,
  currency,
  settledAmount,
}: Readonly<Attributes>): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);
  return (
    <DataList.Row id="total" grayed>
      <DataList.Cell width={70}>
        <Box display="flex" flexDirection="row" gap="0-5">
          <Text fontWeight="bold" color="neutral-textHigh">
            {t('orderSummaryCard.tableAmounts.totalBeforeRefund')}
          </Text>
        </Box>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          <CurrencyPrice
            price={total}
            currency={currency}
            block
            textAlign="right"
            bold
          />
          {settledAmount && <SettledAmount amount={settledAmount} />}
        </Box>
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderSubtotalAmountRow;
